import { render } from "./Onboard.vue?vue&type=template&id=6c97f0d1&scoped=true&lang=pug"
import script from "./Onboard.vue?vue&type=script&lang=js"
export * from "./Onboard.vue?vue&type=script&lang=js"

import "./Onboard.vue?vue&type=style&index=0&id=6c97f0d1&lang=scss"
import "./Onboard.vue?vue&type=style&index=1&id=6c97f0d1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c97f0d1"]])

export default __exports__